export const jumpRoutes = [
  {
    path: '/jump',
    name: 'Jump',
    component: () => import('@/views/Jump/Jump.vue'),
    meta: {
      mainRouteName: 'Pour Now',
    },
  },
]
